import { StreamlineSolveRow } from "@/pages/Sbcs/SbcSetPage/components/StreamlineSolveRow";
import { CustomizeButton } from "@/pages/Sbcs/components/SolveSettings/CustomizeButton";
import { BREAKPOINTS } from "@/settings";
import { useMediaQuery } from "usehooks-ts";

/**
 * A set's toolbar. The backend solves every pool at once, so there is
 * no pool to pick here any more: the club row Streamline sets use takes the
 * slot (import, or the imported state with a note on where the pools went),
 * and everything else stays behind Customize.
 */
export const CustomizeRow = () => {
  const isTouch = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);

  return (
    <div className="flex w-full flex-row items-center justify-between gap-2">
      <StreamlineSolveRow isTouch={isTouch} />

      {/* Icon only on phones: the club row needs the width. */}
      <CustomizeButton compact={isTouch} />
    </div>
  );
};
